// eslint-disable-next-line import/prefer-default-export
export const RETRIEVE_VEHICLES = 'commercial/vehicles/retrieve';
